import type { ReactElement } from 'react';

import styles from './page_block_header.module.css';

const ButtonsSeparator = (): ReactElement => (
  <div className={styles.buttons_separator} />
);

export default ButtonsSeparator;
